import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography, Button, TextField } from '@material-ui/core';
import ReactJson from 'react-json-view';
import { AppContext } from '../../../modules/AppContext';

import { useYodlee } from '../../../modules/Yodlee/Yodlee';

const BASE_URL = 'https://downloads.pronvest.com/download';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    padding: '20px',
    margin: '0',
  },
  content: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2, 0),
  },
  textField: { width: '500px', marginRight: '20px' },
  formRow: { display: 'flex', alignItems: 'center' },
  row: { width: '100%', display: 'flex', justifyContent: 'end' },
}));

export const YodleeLookup = () => {
  const { showToast } = useContext(AppContext);
  const classes = useStyles();
  const [yodleeAccountId, setYodleeAccountId] = useState();
  const [loading, setLoading] = useState(false);
  const [yodleeAccountData, setYodleeAccountData] = useState(null);

  const yodleeObj = useYodlee();

  const handleChange = (event) => {
    setYodleeAccountId(event.target.value);
  };

  const getYodleeAccount = () => {
    setLoading(true);
    yodleeObj
      .getAdminData(yodleeAccountId)
      .then(async (res) => {
        console.log({ res });
        if (res.ok) {
          let data = [];
          try {
            data = (await res.json()) || [];
          } catch (err) {
            console.error(err);
            showToast({
              message: `Error fetching Yodlee Data:: ${err}`,
              type: 'error',
            });
          }
          setYodleeAccountData(data);
        } else {
          showToast({
            message: `Error fetching jobs`,
            type: 'error',
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // useEffect(() => { return () => {}; }, []);

  return (
    <div className={classes.wrapper}>
      <Paper elevation={1} className={classes.content}>
        <Typography variant="h6" className={classes.title}>
          Yodlee Account Data Lookup
        </Typography>
        <section className={classes.formRow}>
          <TextField
            label="Yodlee Account ID"
            variant="outlined"
            className={classes.textField}
            onChange={handleChange}
          />
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={getYodleeAccount}
          >
            Lookup
          </Button>
        </section>
        <section className={classes.mainContent}>
          {yodleeAccountData ? (
            <ReactJson
              src={yodleeAccountData}
              enableClipboard={true}
              collapsed={1}
              collapseStringsAfterLength={false}
              displayDataTypes={false}
              theme="rjv-default"
            />
          ) : (
            'No data yet'
          )}
        </section>
      </Paper>
    </div>
  );
};
